import { Http } from '@samknows/utils';

interface CurrentUserProfileResponse {
  user: {
    appTimezone: string;
    defaultAid: number;
    deleted: boolean;
    email: string;
    firstName: string;
    lastName: string;
    name: string;
    thousandEyesUser: boolean;
    uid: number;
  };
}

interface UpdateUserProfilePayload {
  name: string;
  altoNotificationsEnabled: boolean;
  appTimezone: 'default';
  defaultAid: number;
  email: string;
}

export function getCurrentUserProfile(): Promise<CurrentUserProfileResponse> {
  return Http.request(`/ajax/settings/profile/current-user`, {
    useAuth: false
  });
}

export function updateCurrentUserProfile(
  payload: UpdateUserProfilePayload
): Promise<void> {
  return Http.request(`/ajax/settings/profile/current-user`, {
    method: 'POST',
    body: JSON.stringify(payload),
    useAuth: false
  });
}

interface UpdateUserPasswordPayload {
  currentPassword: string;
  newPassword: string;
  verificationPassword: string;
}

export function updateUserPassword(
  payload: UpdateUserPasswordPayload
): Promise<void> {
  return Http.request(`/ajax/settings/profile/password`, {
    method: 'POST',
    body: JSON.stringify(payload),
    useAuth: false
  });
}

interface CheckPasswordValidityReturn {
  message: string;
  strength: number;
}

export function checkPasswordValidity(
  payload: string
): Promise<CheckPasswordValidityReturn> {
  return Http.request(`/ajax/settings/profile/password/validate`, {
    method: 'POST',
    body: JSON.stringify(payload),
    useAuth: false
  });
}
